import React, {useEffect, useState} from 'react';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import Pill from '../../components/ui/Pill';
import ProgressBar from '../../components/ui/ProgressBar';
import Icon from '../../components/ui/Icon';
import Mascot from '../../components/ui/Mascot';
import MissionSidebar from '../../components/mission/MissionSidebar';
import {api} from '../../lib/api';
import {todaysChallenge, learnCards} from '../../data/mock';
import styles from './Home.module.scss';

export default function Home () {
    const [challenge, setChallenge] = useState(todaysChallenge);
    const [cards, setCards] = useState(learnCards);

    useEffect(() => {
        let alive = true;
        api.home().then(data => {
            if (!alive) return;
            if (data.todaysChallenge) setChallenge(data.todaysChallenge);
            if (data.learnCards?.length) setCards(data.learnCards);
        }).catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    return (
        <div className={styles.page}>
            {/* —— Hero —— */}
            <section className={`cq-container ${styles.hero}`}>
                <div className={styles.heroText}>
                    <Pill color="green" iconLeft={<Icon name="star" size={15} />}>第 1 关已解锁！</Pill>
                    <h1 className={styles.heroTitle}>
                        用积木搭建
                        <br />
                        <span className={styles.hl}>你的专属游戏</span>！
                    </h1>
                    <p className={styles.heroDesc}>
                        加入成千上万的小探险家，在有趣的任务和创意冒险中学习编程。
                        不用打字，也能做出好玩的游戏！
                    </p>
                    <Button to="/quests" size="lg" iconRight={<Icon name="arrowRight" size={22} />}>
                        开始第一个任务
                    </Button>
                </div>

                <div className={styles.heroArt}>
                    <div className={styles.heroScene}>
                        <Mascot size={180} className={styles.heroMascot} />
                        <div className={styles.heroBlocks} aria-hidden="true">
                            <span className={styles.blk1}>当被点击</span>
                            <span className={styles.blk2}>移动 10 步</span>
                            <span className={styles.blk3}>重复 10 次</span>
                        </div>
                    </div>
                    <div className={styles.heroChip}>
                        <span className={styles.chipCheck}><Icon name="check" size={16} /></span>
                        机器人组装完成！
                    </div>
                </div>
            </section>

            {/* —— 今日挑战 —— */}
            <section className={`cq-container ${styles.challenge}`}>
                <MissionSidebar />
                <div className={styles.challengeMain}>
                    <h2 className={styles.sectionTitle}>
                        <Icon name="play" size={22} /> 今日挑战
                    </h2>
                    <Card className={styles.challengeCard}>
                        <div className={styles.treasure} aria-hidden="true">
                            <Icon name="star" size={54} />
                        </div>
                        <div className={styles.challengeBody}>
                            <Pill color="solidBlue">{challenge.tag}</Pill>
                            <h3 className={styles.challengeTitle}>{challenge.title}</h3>
                            <p className={styles.challengeDesc}>{challenge.desc}</p>
                            <div className={styles.challengeProgress}>
                                <ProgressBar value={challenge.progress} color="green" label="任务进度" />
                                <span className={styles.pct}>{challenge.progress}%</span>
                            </div>
                            <Button to="/quests" iconRight={<Icon name="arrowRight" size={18} />} size="sm">
                                继续任务
                            </Button>
                        </div>
                    </Card>
                </div>
            </section>

            {/* —— 边做边学 —— */}
            <section className={`cq-container ${styles.learn}`}>
                <h2 className={styles.learnTitle}>边做边学</h2>
                <div className={styles.learnGrid}>
                    {cards.map(c => (
                        <Card key={c.title} className={styles.learnCard}>
                            <span className={[styles.learnIcon, styles[`ic_${c.color}`]].join(' ')}>
                                <Icon name={c.icon} size={30} />
                            </span>
                            <h3 className={styles.learnCardTitle}>{c.title}</h3>
                            <p className={styles.learnCardDesc}>{c.desc}</p>
                        </Card>
                    ))}
                </div>
            </section>
        </div>
    );
}
